import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function SeaFound() {
  const dateTexts = ['1538年', '8月', '12日'];
  const title = 'S.E.A.設立';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2022/01/sea.jpg';
  const description = (
    <>
      <a href='/fortress-explorations'>
        {'フォートレスエクスプロレーション'}
      </a>
      {'でS.E.A.が設立される。'}
      {'知識の追求を目的として、世界中の探検家、科学者、発明家が多数入会する。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      important
    />
  );
}

export default SeaFound;
